module.exports = __webpack_public_path__ + "img/4.42d8e5b2.jpg";